import { useCallback } from 'react'

import { assetListActionsStatusSlice } from '../store'

export const useActionsStatus = () => {
  const actionsStatus = assetListActionsStatusSlice.useSlice(state => state?.data?.action_status)

  const getActionsStatus = useCallback((biids: string[]) => {
    assetListActionsStatusSlice.setFilters({ biids }, true)
  }, [])

  const findActionsStatusByBiid = useCallback(
    (biid: string) => actionsStatus?.find(actionStatus => actionStatus.biid === biid),
    [actionsStatus]
  )

  return { actionsStatus, getActionsStatus, findActionsStatusByBiid }
}
